export const SELECTSOURCE = 'SELECTSOURCE'
export const SET_LOGO_POSITION = 'SET_LOGO_POSITION'
export const GET_FACILITY_MESSAGE = 'GET_FACILITY_MESSAGE'
